import { render, staticRenderFns } from "./SalesCostOverview.vue?vue&type=template&id=54348741&scoped=true&"
import script from "./SalesCostOverview.vue?vue&type=script&lang=js&"
export * from "./SalesCostOverview.vue?vue&type=script&lang=js&"
import style0 from "./SalesCostOverview.vue?vue&type=style&index=0&id=54348741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54348741",
  null
  
)

export default component.exports